export default "__VITE_ASSET__B4ehXgvj__"